import { Injectable, Inject } from '@angular/core';
import { FormGroup } from '@ngneat/reactive-forms';
import { loadFull } from 'tsparticles';
import { Engine } from 'tsparticles-engine';
import { UtilsBsHotToastService } from '@brunsker/libs/core/utils/hot-toast/src';
import { NewApiUserService } from '../../api/new-api-user/new-api-user.service';
import { MatDialog } from '@angular/material/dialog';
import { UiChangeLoginFormComponent } from '@brunsker/libs/portal-do-vendedor/ui/chenge-login/lib/components/login-form/change-login-form.component';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ChangeAuthDomainService {
  constructor(
    readonly newApiUserService: NewApiUserService,
    private readonly toastService: UtilsBsHotToastService,
    private readonly matDialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  async particlesInit(engine: Engine): Promise<void> {
    await loadFull(engine);
  }

  start(){
    const verify = this.newApiUserService.currentUser$$.value?.primeiroacesso;

    if( verify != 0) return;
    this.document.body.classList.add('dialog-open');
    const dialog = this.matDialog.open(UiChangeLoginFormComponent,{
      disableClose: true,
      hasBackdrop: true,
      width: "380px"
    })

    dialog.componentInstance.submitForm.subscribe((dados: FormGroup<any>) => {

      if (dados.invalid) return;
      const { login, password, newLogin, newPassword } = dados.controls;

      this.newApiUserService
        .changeLogin({
          username: login.value,
          password: password.value,
          newUsername: newLogin.value,
          newPassword: newPassword.value,
        })
        .subscribe((s) => {
          this.matDialog.closeAll();
          this.document.body.classList.remove('dialog-open');
          this.toastService.showSuccess('Auteração realizada com sucesso!');
        });
    });
  }
}
